/* eslint-disable prettier/prettier */
import { apiService } from './api.service';
import { ApiResponse } from '../types';

export interface ReviewAssessmentSubmissionPayload {
	score: number;
	maxscore: number;
	passed: boolean;
	feedback?: string;
}

export interface AssessmentSubmission {
	id: string;
	score: number;
	maxscore: number;
	passed: boolean;
	feedback?: string | null;
	reviewedby?: string | null;
	reviewedat?: string | null;
	[key: string]: any;
}

class ReviewAssessmentSubmissionService {
	/**
	 * Review an assessment submission
	 */
	async reviewSubmission(
		submissionId: string,
		payload: ReviewAssessmentSubmissionPayload
	): Promise<ApiResponse<AssessmentSubmission>> {
		try {
			if (!submissionId) {
				throw new Error('Submission ID is required');
			}

			if (payload.score === undefined || payload.score === null) {
				throw new Error('Score is required');
			}

			if (payload.maxscore === undefined || payload.maxscore === null) {
				throw new Error('Maximum score is required');
			}

			if (payload.score < 0) {
				throw new Error('Score cannot be negative');
			}

			if (payload.maxscore <= 0) {
				throw new Error('Maximum score must be greater than 0');
			}

			if (payload.score > payload.maxscore) {
				throw new Error('Score cannot be greater than maximum score');
			}

			if (typeof payload.passed !== 'boolean') {
				throw new Error('Passed status must be true or false');
			}

			const response = await apiService.put<AssessmentSubmission>(
				`/assessment/${submissionId}/review`,
				{
					score: payload.score,
					maxscore: payload.maxscore,
					passed: payload.passed,
					feedback: payload.feedback?.trim() || undefined,
				}
			);

			if (!response?.success) {
				throw new Error(
					response?.message || 'Failed to review assessment submission'
				);
			}

			return response;
		} catch (error: any) {
			console.error('reviewSubmission service error:', error);

			const message =
				error?.response?.data?.message ||
				error?.response?.data?.error ||
				error?.message ||
				'Failed to review assessment submission';

			throw new Error(message);
		}
	}
}

export const reviewAssessmentSubmissionService =
	new ReviewAssessmentSubmissionService();